import axios from 'axios'

export const recommendationSystemClient = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production' && process.env.RECOMMENDATION_SYSTEM_URL ?  process.env.RECOMMENDATION_SYSTEM_URL : 'https://recommendation-system-prd-jmyusmpnnq-uk.a.run.app/api/v1',
})
